<main class="document-container document_viewer" [class.two-columns]="twoColumns"
  [class.ai-content-mode]="displayAiText" [class.column-view]="twoColumns" role="main"
  aria-label="Pdf viewer, you can use arrow up or down in order to read the document.">

  <a href="#sidebar-content" class="skip-link document-sidebar-skip-link" (click)="onSidebarSkipLinkClick($event)">
    {{'report_component.skip_to_sidebar_content' | translate}}
  </a>

  <!-- Original PDF viewer -->
  <div class="pdf-viewer-container" [class.half-width]="twoColumns">
    <pdf-viewer #viewer id="viewer" tabindex="-1" (pagechanging)="pageChanging($event)" [src]="pdfSrc" [zoom]="zoom"
      [render-text]="true" [fit-to-page]="false" [external-link-target]="'none'" [autoresize]="true"
      [page]="selectedPage" (page-rendered)="pageRendered($event)" [original-size]="false" [show-all]="true"
      style="width: 100%; height: 100%;" (after-load-complete)="onPdfLoad($event)"></pdf-viewer>
  </div>

  <!-- AI-generated PDF viewer, only shown in two-columns mode -->
  <div class="pdf-viewer-container ai-viewer" *ngIf="twoColumns && secondPdfSrc" [class.half-width]="twoColumns">
    <pdf-viewer #viewerSecond id="viewerSecond" tabindex="-1" [src]="secondPdfSrc" [zoom]="zoom" [render-text]="true"
      [fit-to-page]="true" [external-link-target]="'none'" [autoresize]="true" [page]="selectedPage"
      (page-rendered)="pageRendered($event)" [original-size]="false" [show-all]="true"
      style="width: 100%; height: 100%;"></pdf-viewer>
  </div>

  <div *ngIf="showStylometrics" style="overflow-y: scroll !important;">
    <pre>{{ submission?.stylometricsData | json }}</pre>
    <pre>{{ submission?.stylometricsJson | json }}</pre>
  </div>

  <!-- <section class="pdf_btns">
    <button (click)="zoomOut()">-</button>
    <button (click)="zoom0()">⟳</button>
    <button (click)="zoomIn()">+</button>
  </section> -->

  <section class="pdf_btns" aria-label="Document resizing controls">
    <button (click)="zoomIn()"><img src="../../../../../../assets/report_v2/zoom-in.svg" alt="Zoom In"></button>
    <button (click)="zoom0()"><img src="../../../../../../assets/report_v2/resize.svg"
        alt="Resize window to 100%"></button>
    <button (click)="zoomOut()"><img src="../../../../../../assets/report_v2/zoom-out.svg" alt="Zoom Out"></button>
  </section>

  <!-- Add a floating control button for side-by-side view -->
  <!-- <div *ngIf="twoColumns" class="side-by-side-controls">
    <button class="close-side-by-side" (click)="closeSideBySideView()">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Close comparison
    </button>
  </div> -->
</main>